import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../assets/style/BranchForm.css"; // Updated CSS file with USWDS grid
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  designation_name: Yup.string().required("Designation name  is required"),
});

const DesignationForm = ({ onClose, id, fetchData }) => {
  const [singleData, setSingleData] = useState();
  const navigate = useNavigate();
  const singleDesignationData = async () => {
    try {
      const result = await getData(`/api/get-designation/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const handleSubmit = async (values) => {
    try {
      const request_url = id
        ? `/api/update-designation/${id}`
        : "/api/create-designation";
      const postDataResult = await postData(request_url, values);

      toast.success(postDataResult?.message);
      // postDataResult?.success === true && navigate("/master/designation");
      onClose();
      // fetchData();
    } catch (error) {
      // Handle error
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    id && singleDesignationData();
  }, [id]);
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          designation_name: id ? singleData?.designation_name : "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-body">
              <div className="grid-row">
                <div className="grid-col-12">
                  <div className="form-group">
                    <label htmlFor="designation_name">Designation Name</label>
                    <Field
                      id="designation_name"
                      name="designation_name"
                      type="text"
                      placeholder="Enter Designation name"
                      className={
                        errors.designation_name && touched.designation_name
                          ? "input-error"
                          : ""
                      }
                    />
                    <ErrorMessage
                      name="designation_name"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DesignationForm;
